import React from 'react'
import { useQuery } from 'react-query'
import { BadgeText } from '../../components/BadgeText'
import { countPendingRetryFulfillmentErrors } from '../../services'

// Counts ONLY the ones that can already be retried, not all the ones with an error. An order that
// is still waiting for its fiscal invoice is not something the operator can act on, and
// counting it here would turn the badge into a number that is always lit — that is, into noise.
export const FulfillmentErrorsPendingRetryBadge = ({ warehouseId = null }) => {
  const { data, isError } = useQuery(['fulfillment_errors_pending_retry_count', warehouseId], () => countPendingRetryFulfillmentErrors(warehouseId), {
    refetchOnMount: false,
    refetchInterval: 60000,
  })

  return <>{data && !isError && data.count > 0 && <BadgeText>{data.count}</BadgeText>}</>
}
